import {EventHandler} from "../EventDispatcher";
import {IpcMainInvokeEvent} from "electron";
import DocumentDownload from "../../Entity/DocumentDownload";
import getRemoveCompleteDownload from "../../DependencyInjection/removeCompleteDownload";
import getEventDispatcher from "../../DependencyInjection/eventDispatcher";

const eventDispatcher = getEventDispatcher();

const CancelCurrentDownloadListener: EventHandler<DocumentDownload> = async (event: IpcMainInvokeEvent, content: DocumentDownload): Promise<void> => {
    const document: DocumentDownload = DocumentDownload.from(content);

    try {
        await eventDispatcher.dispatch('CancelDownloadManager');
    } catch (error) {
    }

    await eventDispatcher.dispatch('CancelCurrentDownloadAction');
    getRemoveCompleteDownload().remove(document);
    await eventDispatcher.dispatch('ElectronRemoveFile', document.export());
    await eventDispatcher.dispatch('AddCurrentDownloadAction');
}

export default CancelCurrentDownloadListener;